import { render, staticRenderFns } from "./NormalSearch.vue?vue&type=template&id=04280a5b"
import script from "./NormalSearch.vue?vue&type=script&lang=js"
export * from "./NormalSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports